const ErpDirectAssistantMixins = {
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG',
      [{ name: 'SynchronizeProducts', title: '同步产品' },
        { name: 'OrderSynchronization', title: '订单同步归属配置' },
        { name: 'ApiConfigure', title: 'API配置' }
      ])

  },
  methods: {}
}
export default ErpDirectAssistantMixins